import { useEffect, useState } from "react";
import app from "../components/app";
import encrypt from "../components/encrypt"

export const appCookie = {
  // Set a cookie
  set: function (name, value, days = 7, path = '/') {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${encodeURIComponent(value)}; expires=${date.toUTCString()}; path=${path}`;
  },

  // Get a cookie by name
  get: function (name) {
    const cookies = document.cookie.split('; ');
    for (let cookie of cookies) {
      const [key, val] = cookie.split('=');
      if (key === name) return decodeURIComponent(val);
    }
    return null;
  },

  // Delete a cookie
  delete: function (name, path = '/') {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=${path}`;
  },
  appUser:function(data, mode) {
    if(data) {
      appCookie.set("appUser", encrypt.encrypt2(JSON.stringify(data)), mode?1:1/24);
    }
    else {
      if(appCookie.get("appUser")) {
        return JSON.parse(encrypt.decrypt2(appCookie.get("appUser")));
      }
      return {};
    }
  } 
};

export default function Login({onLogin}) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [remember, setRemember] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (email.trim() !== '' && password.trim() !== '') {
        app.fetchUsers({
          "method":"login",
          email,
          password
        }).then(function(response){
          console.log(response);
          if(response.success) {
            if(response.data.status) {
              appCookie.appUser({
                email:response.data.email,
                id:response.data.id,
                name:response.data.name,
                phone:response.data.phone,
                role:response.data.role,
              }, remember)
              onLogin();
            }
            else {
              alert("You are not active user!");
            }
          }
          else {
            alert(response.error);
          }
          
          
        })
        
    } else {
      alert('Invalid credentials');
    }
    // Simple demo authentication
    // if (email === 'admin@example.com' && password === '123456') {
    //     appCookie.set("login", "yes", (1/24))
    //     onLogin();
    // } else {
    //   alert('Invalid credentials');
    // }
  };
    return <div className="login-card">
  <h3 className="text-center mb-4">Login</h3>
  <form onSubmit={handleSubmit}>
    <div className="mb-3">
      <label htmlFor="email" className="form-label">Email address</label>
      <input type="email" className="form-control" id="email" placeholder="Enter email" value={email} onChange={(e) => setEmail(e.target.value)} required />
    </div>
    <div className="mb-3">
      <label htmlFor="password" className="form-label">Password</label>
      <input type="password" className="form-control" id="password" placeholder="Enter password" value={password} onChange={(e) => setPassword(e.target.value)} required />
    </div>
    <div className="d-flex justify-content-between align-items-center mb-3">
      <div className="form-check">
        <input className="form-check-input" type="checkbox" id="remember" onChange={function(e){
          setRemember(e.currentTarget.checked);
        }} />
        <label className="form-check-label" htmlFor="remember">
          Remember me
        </label>
      </div>
      <a href="#" className="text-decoration-none d-none">Forgot Password?</a>
    </div>
    <button type="submit" className="btn btn-primary w-100">Login</button>
    <p className="text-center mt-3 mb-0 d-none">Don't have an account? <a href="#" className="text-decoration-none">Sign Up</a></p>
  </form>
</div>

}
